// extracted by mini-css-extract-plugin
export default {"inputSection":"styles_inputSection__O6XOC","slide-in-bottom":"styles_slide-in-bottom__22QAi"};